import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter,ListGroup, ListGroupItem} from "reactstrap";

const FileUploadPreview = ({
showModel,
setShowModel,
openFileDialog,
allAcceptedFiles,
setallAcceptedFiles,
submitNewMediaMessage,
showLoader
}) => {
    const addFile = () => {
    openFileDialog();
  }

  // below is the same as componentDidMount and componentDidUnmount
	useEffect(() => {
	  }, []);

  const sendFile = async () => {
    toggleModal();
    await submitNewMediaMessage(allAcceptedFiles);
    cancelFile();
  }

  const removeFile = (mediaId) => {
    if(allAcceptedFiles[mediaId]){
			delete allAcceptedFiles[mediaId];
			setallAcceptedFiles({...allAcceptedFiles});
		  }
  }

  const cancelAll = () => {
    setShowModel(!showModel);
    setallAcceptedFiles({});
  }

  const toggleModal = () => {
    setShowModel(!showModel);
  }

  const cancelFile = () => {
    setallAcceptedFiles({});
  }

    return (
      <span className="d-inline-block mb-2 me-2">
        <Modal isOpen={showModel || showLoader} toggle={cancelAll}>
          <ModalHeader toggle={cancelAll}>
            File Preview
          </ModalHeader>

          {showLoader ? (
              <ModalBody>
                Loading...
              </ModalBody>
          ) : (
              <div>
                <ModalBody>
                  <ListGroup>{
                    Object.keys(allAcceptedFiles).map((mediaId) => (
                        <ListGroupItem  key={mediaId} data-type={allAcceptedFiles[mediaId].type}>
                          <div>
                            <span className="filePreviewDialog">
                              <span className="chat-inbox-file-select">
                                {allAcceptedFiles[mediaId].name}
                              </span>
                              <span onClick={() => removeFile(mediaId)} className="btn-close"></span>
                            </span>
                          </div>
                        </ListGroupItem>
                    ))
                  }</ListGroup>
                </ModalBody>
                <ModalFooter>
                  <Button className={'open_chat_btn'} color="success" onClick={cancelAll}>
                    Cancel
                  </Button>
                  <Button color="success" onClick={addFile}>
                    Add More
                  </Button>
                  <Button color="success" onClick={sendFile}>
                    Send
                  </Button>
                </ModalFooter>
              </div>
          )}
        </Modal>
      </span>
    );
}

export default FileUploadPreview;
